<template>
  <div>
    <app-sidebar />
    <div class="rightpart">
      <div class="rightpart_in">
        <div class="tokyo_tm_section">
          <div class="container">
            <!----><!---->
            <div class="tabcontent">
              <div class="tokyo_tm_portfolio">
                <div class="tokyo_tm_title">
                  <div class="title_flex">
                    <div class="left">
                      <span>Portfolio</span>
                      <h3>Creative Portfolio</h3>
                    </div>
                    <!-- <div class="portfolio_filter">
                      <ul>
                        <li>
                          <a class="">All</a>
                        </li>
                        <li>
                          <a class="">Vimeo</a>
                        </li>
                        <li>
                          <a class="">Youtube</a>
                        </li>
                        <li>
                          <a class="">Mix</a>
                        </li>
                        <li>
                          <a class="active">Gallery</a>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>
                <!----><!----><!----><!---->
                <div class="tabcontent">
                  <ul class="portfolio_list">
                    <!---->
                    <li>
                      <a
                        href="https://covid-19-tracker-by-demmy.netlify.app/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div class="inner">
                          <div class="entry tokyo_tm_portfolio_animation_wrap">
                            <img
                              src="../assets/portfolio/3.png"
                              alt="Portfolio"
                              class="image"
                            />
                          </div></div
                      ></a>
                    </li>
                    <li>
                      <a
                        href="https://determined-cori-e630f8.netlify.app/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div class="inner">
                          <div class="entry tokyo_tm_portfolio_animation_wrap">
                            <img
                              src="../assets/portfolio/4.png"
                              alt="Portfolio"
                              class="image"
                            />
                          </div></div
                      ></a>
                    </li>
                    <li>
                      <a
                        href="https://femagexchange.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><div class="inner">
                          <div class="entry tokyo_tm_portfolio_animation_wrap">
                            <img
                              src="../assets/portfolio/5.png"
                              alt="Portfolio"
                              class="image"
                            />
                          </div></div
                      ></a>
                    </li>
                    <li>
                      <a
                        href="https://toptraderbot.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><div class="inner">
                          <div class="entry tokyo_tm_portfolio_animation_wrap">
                            <img
                              src="../assets/portfolio/6.png"
                              alt="Portfolio"
                              class="image"
                            />
                          </div></div
                      ></a>
                    </li>
                    <li>
                      <a
                        href="https://zen-murdock-533d87.netlify.app/"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><div class="inner">
                          <div class="entry tokyo_tm_portfolio_animation_wrap">
                            <img
                              src="../assets/portfolio/7.png"
                              alt="Portfolio"
                              class="image"
                            />
                          </div></div
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!----><!---->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from './shared/sidebar.vue';
export default {
  name: 'Portfolio',
  components: {
    'app-sidebar': sidebar,
  },
};
</script>
